import React, { useState, useEffect } from 'react'
import { Box, Button, Stack } from '@mui/material'
import MenuScanLoadingScreen from '../../components/ui/MenuScanLoadingScreen'

/**
 * Demo page for the MenuScanLoadingScreen component
 * Shows the premium minimal loading screen for the Scan Menu feature
 */
const MenuScanLoadingDemo: React.FC = () => {
  const [showLoading, setShowLoading] = useState(false)
  const [progress, setProgress] = useState(0)
  const [isIndeterminate, setIsIndeterminate] = useState(true)

  // Simulate progress increment
  useEffect(() => {
    if (!showLoading || isIndeterminate) return

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          setShowLoading(false)
          return 0
        }
        return prev + Math.random() * 30
      })
    }, 500)

    return () => clearInterval(interval)
  }, [showLoading, isIndeterminate])

  if (showLoading) {
    return (
      <MenuScanLoadingScreen
        statusText="Scanning menu…"
        secondaryText="Identifying dishes and ingredients."
        progress={isIndeterminate ? undefined : Math.min(progress, 100)}
        isIndeterminate={isIndeterminate}
      />
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '40px 20px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack spacing={3} sx={{ maxWidth: '400px' }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            setShowLoading(true)
            setIsIndeterminate(true)
            setProgress(0)
          }}
        >
          Show Indeterminate Loading
        </Button>

        <Button
          variant="contained"
          color="secondary"
          size="large"
          onClick={() => {
            setShowLoading(true)
            setIsIndeterminate(false)
            setProgress(0)
          }}
        >
          Show Determinate Loading
        </Button>
      </Stack>
    </Box>
  )
}

export default MenuScanLoadingDemo
